import {convertToEmbedLink} from '../utils';
import {BlockContainer} from '../styled';

const MapBlockView = ({url}: {url: string}) => {
  return (
    <BlockContainer>
      <iframe
        width="100%"
        height="400"
        referrerPolicy="no-referrer-when-downgrade"
        src={convertToEmbedLink(url)}
        allowFullScreen
        title="map"
      ></iframe>
    </BlockContainer>
  );
};

export {MapBlockView};
